module.exports = __webpack_public_path__ + "static/media/trigger_soundi 3-2-Audio 1.ec221fd6.mp3";